import { BASE_URL, MasterInstance } from "@/instance/axios";
import { createMutationKeys, createQueryKeys } from "@lukemorales/query-key-factory";
import {
  MasterApiItemStandardAttachmentsGetRequest,
  MasterApiItemStandardAttachmentsItemStandardAttachmentIdDeleteRequest,
} from "@sizlcorp/sizl-api-document/dist/models";
import axios from "axios";

export const WORK_STANDARD_KEY = "workStandard";

export const workStandardFile = {
  upload: ({ itemId, FormData }: { itemId: string; FormData: FormData }) => {
    return axios.post(`${BASE_URL}/items/${itemId}/uploadWorkStandardFile`, FormData, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("authToken"),
      },
    });
  },
  download: (filePath: string) => {
    return axios.post(
      `${BASE_URL}/s3/download`,
      { keys: [filePath], type: "attachments" },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
        responseType: "blob",
      },
    );
  },
};

export const workStandard = createQueryKeys(WORK_STANDARD_KEY, {
  all: null,
  get: (params: MasterApiItemStandardAttachmentsGetRequest) => {
    const query = { ...params, sort: params.sort?.length ? params.sort : "-createdAt" };
    if (Array.isArray(params.query?.$and) && params.query?.$and.length > 0) {
      query["query"] = JSON.stringify(params.query);
    }
    if (params.search) {
      query["search"] = params.search;
      query["searchFields"] = params.searchFields;
    }

    return {
      queryKey: [query, JSON.stringify(query.query)],
      queryFn: () => MasterInstance.itemStandardAttachmentsGet(query),
    };
  },
});

export const mutateWorkStandard = createMutationKeys(WORK_STANDARD_KEY, {
  delete: (params: MasterApiItemStandardAttachmentsItemStandardAttachmentIdDeleteRequest) => {
    return {
      mutationKey: [params.itemStandardAttachmentId],
      mutationFn: () =>
        MasterInstance.itemStandardAttachmentsItemStandardAttachmentIdDelete(params),
    };
  },
});
